import axios from 'axios';

const API_URL = "https://se2ouk5n2jtry6gjvpyd6pv3pq0qfwkk.lambda-url.us-east-2.on.aws";

const ExecuteLogin = async(user, password) =>
{
  try{
    // Call Lambda backend, which proxies the request to Omnitracs
    const payload = {
      user: user,
      password: password
    };
    
    const response = await axios.post(API_URL, payload);
    console.log(response.data);
    return response.data; 
  }
  catch(error)
  {
    console.log(error);
    
    // Handle different error scenarios
    if (error.response?.status === 403) {
      return {
        error: 'Unauthorized: You do not have access to this system'
      };
    }
    
    return {
      error: error.response?.data?.error || error.message
    }
  }
}

export default ExecuteLogin;